var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGodownMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.486 31.663 51.743 2.559a3.001 3.001 0 0 0-3.486 0L7.517 31.66A6.001 6.001 0 0 0 5 36.543V92c0 3.308 2.691 6 6 6h78c3.309 0 6-2.692 6-6V36.543c0-1.936-.94-3.761-2.514-4.88zM77 92H53V68h24zM62 62H38V38h24zm-15 6v24H23V68zm36 24V68c0-3.308-2.691-6-6-6h-9V38c0-3.308-2.691-6-6-6H38c-3.309 0-6 2.692-6 6v24h-9c-3.309 0-6 2.692-6 6v24h-6V36.543L50 8.685l39 27.858L89.004 92z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodownMaster);
export default __webpack_public_path__ + "static/media/godown-master.4a4a0bb0295959eec29132eb5f0adc57.svg";
export { ForwardRef as ReactComponent };